module.exports = __webpack_public_path__ + "static/img/profile-icon04.a2a0582.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/profile-icon04.png
// module id = 2952
// module chunks = 1